/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_DescriptionInputs */



/**
* | output |
* | --- |
* | "No Description" |
*
* @param {No_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_description = /** @type {((inputs?: No_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune description")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Beschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna descrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет описания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin descripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("説明なし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई विवरण नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem descrição")
	return /** @type {LocalizedString} */ ("No Description")
});